import axios from "axios";
import { documents } from "@/urls";
import { mesi } from "@/constants";

export default {
  namespaced: true,
  state: {
    payrolls: [],
    last: {},
    current: {},
    bpNonLetti: null,
  },
  getters: {
    payrolls: (state) => state.payrolls,
    last: (state) => state.last,
    current: (state) => state.current,
    bpNonLetti: (state) => state.bpNonLetti,
  },
  mutations: {
    SET_PAYROLLS(state, data) {
      state.payrolls = data;
    },
    RESET_PAYROLLS(state) {
      state.payrolls.length = 0;
      state.payrolls = [];
    },
    SET_LAST(state, data) {
      state.last = data;
    },
    SET_CURRENT(state, data) {
      state.current = data;
    },
    SET_BPNONLETTI(state, data) {
      state.bpNonLetti = data;
    },
    DECREASE_BPNONLETTI(state) {
      state.bpNonLetti--;
    },
    UNMARK_BP(state, id) {
      const i = state.payrolls.findIndex((item) => item.id === id);
      state.payrolls[i].statoLettura = 2;
    },
  },
  actions: {
    setBpnonletti({ commit }, data) {
      commit("SET_BPNONLETTI", data);
    },
    resetCurrent({ commit }) {
      commit("SET_CURRENT", {});
    },
    resetLast({ commit }) {
      commit("SET_LAST", {});
    },
    resetPayrolls({ commit }) {
      commit("RESET_PAYROLLS");
    },
    async fetchPayrolls(
      { dispatch, commit, rootGetters },
      payload = { da: null, a: null }
    ) {
      commit("RESET_PAYROLLS");
      const account = rootGetters["account/account"];
      if (payload.da) payload.da = payload.da.replace("-", "");
      if (payload.a) payload.a = payload.a.replace("-", "");
      try {
        const { data } = await axios.get(
          `${documents.FETCH_PAYROLLS_URL}/${account.codFiscale}`,
          { params: { annomese_da: payload.da, annomese_a: payload.a } }
        );
        commit("SET_PAYROLLS", data.reverse());
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
    async fetchPayrollById({ dispatch }, id) {
      try {
        const { data } = await axios.get(`${documents.FETCH_PAYROLL_URL}/${id}`);
        return new Promise(resolve => resolve(data));
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
    async fetchLastPayroll({ dispatch, commit, getters }) {
      commit("SET_LAST", {});
      try {
        await dispatch("fetchPayrolls");
        commit("SET_LAST", getters.payrolls[0]);
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
    downloadPayroll({ dispatch, commit }, payload) {
      axios({
        url: `${documents.DOWNLOAD_PAYROLL_URL}/${payload.id}`,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          var extension = payload.nomeFile.split(".").pop();
          if (extension !== "pdf") {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            const nomeFile = payload.descrizione
              ? `${payload.descrizione}_${mesi[payload.mese - 1]}_${payload.anno
              }.${payload.nomeFile.slice(-3)}`
              : payload.nomeFile;
            fileLink.setAttribute("download", nomeFile);
            document.body.appendChild(fileLink);

            fileLink.click();
          } else {
            var file = new Blob([response.data], { type: "application/pdf" });
            var url = URL.createObjectURL(file);
            window.open(url);
          }

          if (payload.statoLettura !== 2) {
            commit("DECREASE_BPNONLETTI");
            commit("UNMARK_BP", payload.id);
          }
        })
        .catch((err) =>
          dispatch("snackbar/openErrorSnackbar", err, { root: true })
        );
    },
  },
};
